import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import UnderConstruction from "../container/Blank/UnderConstruction";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Transportation = () => {
  const show = true;
  if (show) {
    return (
      <React.Fragment>
        <SEO title="Transportation | ICSI 2022" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content">
            <h3>Xi&apos;an Xianyang International Airport</h3>
            <br/>

            <p>
              <img
                src="./images/xian/tr1.jpg"
                width={650}
                // height={300}
              />
            </p>
            <br/>
            <p>
            Xi&apos;an Xianyang International Airport (IATA: XIY, ICAO: ZLXY) is the main airport serving Xi&apos;an, Shaanxi Province, as well as the whole Guanzhong area. Covering an area of 5 square kilometres (1.9 sq mi), it is the largest airport in Northwest China, and the second largest airport in Northern China. The airport was the hub for China Northwest Airlines until the company was merged into China Eastern Airlines in 2002. Xi&apos;an Airport is also the hub for Joy Air and Hainan Airlines. Xi&apos;an Xianyang International Airport is a Skytrax 4-star airport.
            </p>

            <p>
              For more information, please visit{" "}
              <a href="http://www.xxia.com/">http://www.xxia.com/</a>
            </p>

            <p>&nbsp;</p>
            <h3>Xi&apos;an North railway station</h3>
            <br/>
            <img
              src="./images/xian/tr2.jpg"
              width={650}
              />
            <p>
              <br/>
            Xi&apos;an North railway station is a railway station on the Zhengxi Passenger Railway, Xibao Passenger Railway and Daxi Passenger Railway. The station is located in Weiyang District of Xi&apos;an, the capital of Shaanxi province. It is some 10 km (6.2 mi) north of the city centre and the Xi&apos;an railway station. The station has 34 platforms. It is the largest railway station in Northwest China.
            </p>

            <p>&nbsp;</p>
            <h3>Xi&apos;an railway station</h3>
            <br/>
            <img
              src="./images/xian/tr3.jpg"
              width={650}
              />
            <p>
              <br/>
            Xi&apos;an railway station is one of the two main passenger railway stations of Xi&apos;an, the capital of China&apos;s Shaanxi Province. Located on the Longhai Railway and just to the north of Xi&apos;an&apos;s historical walled city, the station had long been the main train station for the Xi&apos;an metropolitan area.
            </p>

            {/* <p>
              From Qingdao Railway Station -&gt; Subway line 3 -&gt; May Fourth
              Square Station -&gt; Subway line 2 -&gt; Miaoling Road Station
              -&gt; Qingdao Blue Horizon Hotel Laoshan
            </p>

            <p>&nbsp;</p>
            <h3>To Ocean University Station</h3>
            <p>
              <img
                src="http://39.98.207.139:8080/icsi2021/wp-content/uploads/transport.jpg"
                width={400}
              />
            </p>
            <p>
              From Qingdao International Airport -&gt; 701 Busline Qingdao
              International Airport Station -&gt; Qingdao Car East Station -&gt;
              Subway line 2, Liaoyang East Road Station -&gt; Miaoling Road
              Station -&gt; Subway line 11 , Miaoling Road Station -&gt; Ocean
              University Station
            </p>
            <p>
              Travel time from the airport to Ocean University of China is one
              and a half hours. Airport Line 1 (bus 701) runs every hour from
              the airport to the East Bus Station and tickets can be purchased
              at the ticket counter in the bus for 20RMB in cash or by using the
              Qindao Pass card on the bus, then transfer to Metro Line 2 and
              change to Metro Line 11 in the station to reach Ocean University
              Station and tickets can be purchased at the ticket machine in the
              Metro station for 4RMB.
            </p> */}
          </div>
        </EmptyTwo>
        {/* <AboutFive />
				  <TestimonialContainer classOption="bg-primary-blue" />
				  <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
  else
  {
	return (
		<React.Fragment>
        <SEO title="Transportation | ICSI 2022" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
			<UnderConstruction/>
        </EmptyTwo>
        {/* <AboutFive />
				  <TestimonialContainer classOption="bg-primary-blue" />
				  <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
	);
  }
};

export default Transportation;
